export const NONE = 0
export const DOMAIN_PANE = 1
export const USERPW_PANE = 2
export const HELP_PANE = 3